import React from 'react';
import { styled } from '@mui/system';
import ScrollToTop from 'components/ScrollToTop';

// Render as <main> so every page has the single landmark axe / Lighthouse
// expect. MainLayout is used exactly once per route, so this stays valid.
//
// `minHeight: 100vh` keeps the Footer below the viewport while data-driven
// sections are still loading. Without it, the prerendered HTML produced a
// short page (API-fetched lists empty) and the Footer briefly sat inside
// the viewport; React's mount then removed and re-inserted the Footer
// elsewhere, scoring a 0.24 CLS spike on the home page.
const MainLayoutContainer = styled('main')(({ theme, grey, styles = {} }) => ({
  background: grey ? theme.palette.grey[50] : theme.palette.background.default,
  position: 'relative',
  margin: '0 auto',
  width: '100%',
  minHeight: '100vh',
  boxSizing: 'border-box',
  overflowX: 'clip',
  ...styles
}));

const MainLayout = ({ children, grey, disableScrollTop, styles }) => {
  return (
    <MainLayoutContainer grey={grey} id={'main_layout'} styles={styles}>
      {children}
      {disableScrollTop ? null : <ScrollToTop />}
    </MainLayoutContainer>
  );
};

export default MainLayout;
